import { render, staticRenderFns } from "./GroupsList.vue?vue&type=template&id=6236bd26&scoped=true&"
import script from "./GroupsList.vue?vue&type=script&lang=js&"
export * from "./GroupsList.vue?vue&type=script&lang=js&"
import style0 from "./GroupsList.vue?vue&type=style&index=0&id=6236bd26&scoped=true&lang=css&"
import style1 from "./GroupsList.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6236bd26",
  null
  
)

export default component.exports